import React from "react";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import parse from "html-react-parser";

// css
import "./Home.scss";

// img
import candleBg from "../../../Assets/images/candleBg.png";
import { useFetchHomePageQuery } from "store/services/user.service";
import Loader from "components/shared/Loader";

const Home = () => {
  const { data: homeContent, isLoading, error } = useFetchHomePageQuery();

  if (isLoading) {
    return (
      <div className="fixed-loader">
        <Loader />
      </div>
    );
  }
  if (!homeContent) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "100vh" }}
      >
        <h5>Data not found</h5>
      </div>
    );
  }

  return (
    <>
      <section
        className="home position-relative"
        style={{
          backgroundColor: "#fafafa",
          backgroundImage: `url(${candleBg})`,
          backgroundSize: "cover",
          backgroundPosition: "top center",
          zIndex: 9,
        }}
      >
        <Container>
          <Row className="justify-content-center">
            <Col lg="12" className="my-2">
              <div className="content">
                {parse(homeContent)}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default Home;
